import React from 'react';
import SendMessageService from '../../../../../containers/app/common/SendMessageService';
import { setPhoneFormat } from '../../../../../lib/common';
import {
  ACCOUNT_SELLER_BUSINESS_TYPE_SELECT_LIST,
  ACCOUNT_SELLER_BUSINESS_TYPE_TEXT,
  ACCOUNT_SELLER_STATUS_SELECT_LIST,
  ACCOUNT_SELLER_STATUS_TEXT,
} from '../../../../../constants/service/app/accountSellerConstants';
import { AMONDZ_MEMBER_TYPE } from '../../../../../constants/service/common/utilConstants';
import ColumnInputFilter from '../../../../../components/table/ReactTableColumnFilter';
import SelectColumnFilter from '../../../../../components/table/SelectColumnFilter';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';

/**
 *  판매점 리스트 컬럼
 */
const setSellerTableColumns = (onChangeFilterOption) => {
  return [
    {
      accessor: 'storeId',
      Header: '브랜드 번호',
      id: 'storeId',
      sortable: true,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.value} />,
      Filter: ({ column }) => <ColumnInputFilter onChange={onChangeFilterOption} option={column} />,
      filter: 'equal',
    },
    {
      accessor: (row) => row.store.status,
      Header: '판매점 상태',
      id: 'status',
      // 해당옵션을 사용해서 소팅 기능을 중지할 수 있습니다.
      disableSortBy: true,
      // 해당옵션을 사용해서 필터를 숨길 수 있습니다.
      // disableFilters: true,
      Cell: (row) => ACCOUNT_SELLER_STATUS_TEXT[row.value] || '_',
      Filter: ({ column }) => (
        <SelectColumnFilter list={ACCOUNT_SELLER_STATUS_SELECT_LIST} column={column} onChange={onChangeFilterOption} />
      ),
    },
    {
      accessor: (row) => row.store.businessType,
      Header: '판매자 유형',
      id: 'businessType',
      disableSortBy: true,
      Cell: (row) => ACCOUNT_SELLER_BUSINESS_TYPE_TEXT[row.value] || '_',
      Filter: ({ column }) => (
        <SelectColumnFilter
          list={ACCOUNT_SELLER_BUSINESS_TYPE_SELECT_LIST}
          column={column}
          onChange={onChangeFilterOption}
        />
      ),
    },
    {
      accessor: (row) => row.store.storeName,
      Header: '판매점명',
      id: 'storeName',
      disableSortBy: true,
      Filter: ({ column }) => <ColumnInputFilter onChange={onChangeFilterOption} option={column} />,
    },
    {
      accessor: 'name',
      Header: '담당자',
      id: 'name',
      disableSortBy: true,
      Filter: ({ column }) => <ColumnInputFilter onChange={onChangeFilterOption} option={column} />,
    },
    {
      accessor: 'email',
      Header: '이메일',
      id: 'email',
      disableSortBy: true,
      Filter: ({ column }) => <ColumnInputFilter onChange={onChangeFilterOption} option={column} />,
    },
    {
      accessor: 'phone',
      Header: '핸드폰',
      id: 'phone',
      disableSortBy: true,
      Cell: (row) => (
        <SendMessageService
          text={setPhoneFormat(row.value)}
          memberType={AMONDZ_MEMBER_TYPE.SELLER}
          targetId={row.row?.original.storeId}
        />
      ),
      Filter: ({ column }) => <ColumnInputFilter type="tel" onChange={onChangeFilterOption} option={column} />,
    },
    {
      accessor: 'extraPhone',
      Header: '유선전화',
      id: 'extraPhone',
      disableSortBy: true,
      Cell: (row) => (row.value ? setPhoneFormat(row.value) : '-'),
      Filter: ({ column }) => <ColumnInputFilter type="tel" onChange={onChangeFilterOption} option={column} />,
    },
    {
      accessor: (row) => row.store.storeAddresses[0].city,
      Header: '매장상주지역',
      id: 'city',
      disableSortBy: true,
      Filter: ({ column }) => <ColumnInputFilter onChange={onChangeFilterOption} option={column} />,
    },
    {
      accessor: (row) => row.store.email,
      Header: '전자세금계산서 이메일',
      id: 'storeEmail',
      disableSortBy: true,
      Filter: ({ column }) => <ColumnInputFilter onChange={onChangeFilterOption} option={column} />,
    },
  ];
};

export default setSellerTableColumns;
